import axios from 'axios';
import BaseService from './baseService';
import { AuthState } from '@okta/okta-auth-js';

export default class AreaService extends BaseService {
    constructor() {
        super();
    }
    public async getRootAreas(authState: AuthState | null){
        try {
            const response = await axios.get(`${this.REACT_APP_API_BASE_URL}/areas/root`, this.getHeaders(authState));
            return response.data;
        } catch (error) {
            console.error("Error fetching root areas:", error);
            throw error;
        }
    }

    public async getAreasByParentId(parentId:string, authState: AuthState | null){
        try {
            const response = await axios.get(`${this.REACT_APP_API_BASE_URL}/areas/parentId/${parentId}`, this.getHeaders(authState));
            return response.data;
        } catch (error) {
            console.error("Error fetching root areas:", error);
            throw error;
        }
    }

    public async createArea(areaName: string, parentId: string | null, authState: AuthState | null) {
        try {
            const response = await axios.post(`${this.REACT_APP_API_BASE_URL}/area`, 
                {
                    name: areaName,
                    parentId: parentId
                }, 
                this.getHeaders(authState)
            );

            return response.data;
        } catch (error) {
            console.error("Error creating area:", error);
            throw error;
        }
    }
}